export default "__VITE_PUBLIC_ASSET__d04ec84a__"